<template>
  <div>
    <template v-if="isEntryRoute || isDetailRouteWithoutParameter">
      <entity-entry-header :entityKey="eCurrent.key" :title="$t(`views.${eCurrent.key}.title`)"/>
    </template>

    <!-- if this is active route (e.g. /users) -->
    <template v-if="isEntryRoute">
      <b-row class="mb-3" align-h="between">
        <b-col cols="auto"></b-col>
        <b-col cols="auto">
          <b-button variant="outline-primary" @click="navigate('Users.Add')"><b-icon icon="plus"/> {{ $t('views.users.button.adduser') }}</b-button>
        </b-col>
      </b-row>

      <entity-entry-table :entityKey="eCurrent.key" :tableSettings="table" searchable>
        <template #cell(requiredactions)="data">
          <div class="badge-group">
            <b-badge v-for="action in data.cell.item.requiredactions" :key="action" variant="warning">{{ action }}</b-badge>
          </div>
        </template>
      </entity-entry-table>
    </template>

    <!-- if subroute is active route (e.g. /users/detail/:userid) -->
    <section v-else-if="isDetailRouteWithParameter">
      <entity-detail-header :entityKey="eCurrent.key" :entityId="eCurrent.id">
        <template #default="data">
          <dl class="detailheader-list">
            <dt class="sr-only">{{ $t('components.entity.detailheader.name.label') }}</dt>
            <dd><h1>{{ data.label }}</h1></dd>

            <div class="w-100"></div>
            <dt>{{ data.definition.$properties.email.translations[$i18n.locale].name }}</dt>
            <dd>{{ data.entity.email }}</dd>
          </dl>
        </template>
      </entity-detail-header>

      <router-view/>
    </section>

    <!-- if subroute is active route (e.g. /users/add) -->
    <router-view v-else-if="isDetailRouteWithoutParameter"/>
  </div>
</template>

<script>
import { CLASS_TABLE_FIELD_KEY_UNKNOWN } from '@/assets/js/config/client'

import { TableHelper } from '@/assets/js/helper/table'

import MixinEntityBase from '@/components/mixins/EntityBase'
import EntityEntryHeader from '@/components/entity/EntryHeader'
import EntityEntryTable from '@/components/entity/EntryTable'
import EntityDetailHeader from '@/components/entity/DetailHeader'

const ENTITY_KEY = 'users'

export default {
    name: 'Users',
    mixins: [MixinEntityBase],
    components: {
        EntityEntryHeader,
        EntityEntryTable,
        EntityDetailHeader
    },
    data () {
        return {
            entityKey: ENTITY_KEY,
            table: {
                helper: TableHelper,
                mapper: this.tableEntitiesMapper,
                options: {
                    fields: {
                        sorting: [CLASS_TABLE_FIELD_KEY_UNKNOWN, 'requiredactions'],
                        labelKey: `views.${this.$options.name.toLowerCase()}.table.label.{field}`,
                        class: {
                            requiredactions: 'cell-align-right'
                        },
                        thClass: {
                            requiredactions: 'cell-min cell-nowrap'
                        }
                    }
                },
                events: {
                    rowClicked: this.tableRowClicked
                }
            }
        }
    },
    computed: {
        isEntryRoute () {
            return Object.values(this.$route.matched[this.$route.matched.length - 1].components).find(c => c.name === this.$options.name) !== undefined
        },
        isDetailRouteWithParameter () {
            return this.$route.matched[this.$route.matched.length - 1].path.indexOf(`/:${this.eCurrent.paramKey}`) >= 0
        },
        isDetailRouteWithoutParameter () {
            return !this.isEntryRoute && !this.isDetailRouteWithParameter
        }
    },
    methods: {
        tableEntitiesMapper (entities, definition) {
            return entities
                .map(e => Object.assign({}, e, {
                    $routerLink: {
                        name: `${this.$options.name}.Detail`,
                        params: {
                            [this.eCurrent.paramKey]: e.id
                        }
                    }
                }))
        },
        tableRowClicked (entity) {
            this.$router.push(entity.$routerLink)
        }
    },
    created () {
        TableHelper.rowClassHook(entity => entity.$routerLink ? 'has-routerlink' : null)
    }
}
</script>

<style lang="scss"></style>
